/**
 * Env-gated Morisawa webfont loader.
 *
 * Injects a <link rel="stylesheet"> pointing at the Morisawa webfont CSS
 * endpoint (delivers UDデジタル教科書体 as a real webfont) when configured via
 * REACT_APP_MORISAWA_WEBFONT_URL. When the env var is unset or empty this is a
 * complete no-op — no DOM changes, no network requests — so environments/
 * participants without a Morisawa membership are unaffected and simply fall
 * back to the existing local()-only @font-face.
 *
 * The URL is restricted to the morisawafonts.net origin: an env var is a
 * build-time input, not a trusted-operator-only one, so we guard against it
 * becoming a vector for injecting an arbitrary CSS stylesheet host.
 */

const ALLOWED_URL_PREFIX = 'https://morisawafonts.net/';
const MARKER_ATTR = 'data-morisawa-webfont';

export function installMorisawaWebfont() {
  const url = process.env.REACT_APP_MORISAWA_WEBFONT_URL;
  if (!url) {
    return;
  }
  if (!url.startsWith(ALLOWED_URL_PREFIX)) {
    console.warn(
      `[morisawaWebfont] REACT_APP_MORISAWA_WEBFONT_URL must start with "${ALLOWED_URL_PREFIX}"; ignoring configured value.`
    );
    return;
  }
  // Idempotent: repeated calls (double invocation, StrictMode, etc.) must not
  // accumulate duplicate <link> tags.
  if (document.querySelector(`link[${MARKER_ATTR}]`)) {
    return;
  }

  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://morisawafonts.net';
  preconnect.setAttribute(MARKER_ATTR, 'preconnect');
  document.head.appendChild(preconnect);

  const stylesheet = document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.href = url;
  stylesheet.setAttribute(MARKER_ATTR, 'stylesheet');
  document.head.appendChild(stylesheet);
}
